import useCertificationBadge from "./UseCertificationBadge";

import style from './CertificationBadge.module.css';
import { Fragment } from "react";

const CertificationBadge = ({ certification }) => {
  const { certificationBadge } = useCertificationBadge(certification.certificationBadgeImageUrl);

  if (certificationBadge) {
    return (
      <div className="col-md-4 col-xs-6">
        <div className={style.CertificationBadge}>
          <img src={certificationBadge} alt="Certification" />
        </div>
      </div>
    );
  }
  else {
    return (<Fragment />)
  }
};

export default CertificationBadge;